import { setLocalStorageLoginToken } from "src/utils/localStorageWorker";
import { DeviceType } from "src/globalTypes/device";
import {
  requestGoogleLogin,
  successGoogleLogin,
  errorGoogleLogin,
} from "../actionCreators/authentication/googleLoginCreator";
import * as requests from "../../../requests/login/requestCreators";
import { EwaThunk } from "../../types";
import flowioast from "../../../utils/flowioast";

// proc se sem predavaj parametry? tohle by mel tahnout google jwt sebou
const googleLogin =
  (token: string, deviceType: DeviceType): EwaThunk =>
  async (dispatch, getState) => {
    const localState = getState().login;
    if (
      localState.googleLoggedIn &&
      localState.user !== null &&
      localState.user !== undefined
    ) {
      return;
    }

    dispatch(requestGoogleLogin());
    let userDto = localState.user;
    let { isUserAdmin } = localState;

    try {
      if (userDto === undefined || userDto === null) {
        const response = await requests.googleLogin(token, deviceType);

        if (response.status === 200) {
          userDto = response.data;

          // todo: Authorization
          if (userDto.token) {
            setLocalStorageLoginToken(userDto.token);
          }

          const { data } = await requests.isUserAdmin();
          isUserAdmin = data;
        }
      }
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e: any) {
      if (e.response.data === "Wrong user name") {
        flowioast.error.fromIntlBase("login.google", e);
      }
      dispatch(errorGoogleLogin(e.toString()));
    }
    dispatch(successGoogleLogin(userDto, isUserAdmin));
  };

export default googleLogin;
